import IFormModel from "@/models/IFormModel";
import {ValidationRule} from "@/declarations/ValidationRule";
import ReportRules from "@/models/report/ReportRules";

export default class ReportCreate implements IFormModel {

	public orderId: string | null = null;
	public userId: string | null = null;
	public planningEntryId: string | null = null;
	public date: string | null = null;
	public fromTime: string | null = null;
	public toTime: string | null = null;
	public breakDuration: string | null = null;
	public licensePlate: string | null = null;
	public notesDriver: string | null = null;

	public reset(): void {
		this.orderId = null;
		this.userId = null;
		this.planningEntryId = null;
		this.date = null;
		this.fromTime = null;
		this.toTime = null;
		this.breakDuration = null;
		this.licensePlate = null;
		this.notesDriver = null;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'orderId':
				return ReportRules.orderIdRules;
			case 'userId':
				return ReportRules.userIdRules;
			case 'planningEntryId':
				return ReportRules.planningEntryIdRules;
			case 'date':
				return ReportRules.dateRules;
			case 'fromTime':
				return ReportRules.fromTimeRules;
			case 'toTime':
				return ReportRules.toTimeRules;
			case 'breakDuration':
				return ReportRules.breakDurationRules(this.fromTime, this.toTime);
			case 'licensePlate':
				return ReportRules.licensePlateRules;
			default:
				return [];
		}
	}

}
